import parsePhoneNumber from 'libphonenumber-js';

export function formatPhoneNumber(value) {
  if (!value) return '';

  const phoneNumber = parsePhoneNumber(value);
  if (!phoneNumber) return value;

  if (phoneNumber.country === 'US') return phoneNumber.formatNational();
  return phoneNumber.formatInternational();
}
